// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { Toastr } from "../../revvComponents";

// Components Imports
import CreateDocFormFields from "./CreateDocFormFields";
import TemplateSelection from "./TemplateSelection";
import UploadTemplate from "./UploadTemplate";

import { PATHS, EVENTS } from "../../constants";
import { AmplitudeUtils, GlobalUtils } from "../../utils";
// Actions Imports
import { DocumentTemplateActions } from "../../actions";
import {
  saveDocument,
  updateSelectedDocCategory,
  createDocumentAndContent,
} from "../../actions/DocumentActions";
import { deleteDocumentComponentService } from "../../actions/DocumentActions/services";

import CreateDocumentNotes from "../RevvEditor/createDocumentNotes";
import { generateDocumentID } from "../../actions/QuotesActions/QuotesService";

import { makeDocTitle } from "./methods";
import LZLoader from "../../commonComponents/LZLoader";

// Destructuring
const { fetchDocumentTemplatesById } = DocumentTemplateActions;
const { handleApiErrMsg, writeDataToLocalStorage } = GlobalUtils;

const QUOTE_TYPE_NAME = "Quote/Order Form";

class CreateDocPopup extends Component {
  state = {
    selectedCategoryID: null,
    selectedCategoryName: "",
    turnAroundDate: moment().format(),
    docURI: null,
    docSource: "template",
    selectedTemplate: null,
    loadingTemplates: false,
    showTemplateSelection: true,
    errMsg: "",
    isLoading: false,
  };

  componentDidMount() {
    this._fetchTemplates();
  }

  // Fetch the defaults templates
  _fetchTemplates = () => {
    const quoteItem = this.props.documentTypes.find(
      item => item.name === QUOTE_TYPE_NAME,
    );
    if (quoteItem) {
      this._selectCategory(QUOTE_TYPE_NAME, quoteItem.id);
    } else if (!this.props.quote) {
      this._selectCategory(QUOTE_TYPE_NAME, 3);
    }
  };

  _setTemplateSelectionView = flag => {
    this.setState({ showTemplateSelection: flag });
  };

  _setErrMsg = msg => {
    this.setState({ errMsg: msg });
  };

  _setDocUri = uri => {
    this.setState({ docURI: uri });
  };

  _setTurnAroundDate = date => {
    this.setState({ turnAroundDate: moment(date).format() });
  };

  _postDocCreationAction = (docNo, revisionNo) => {
    this.setState({ isLoading: false });
    // this.setState({ showBtnLoader: false });
    writeDataToLocalStorage("documentPageSource", this.props.source);
    this.props.history.push(`${PATHS.DOCUMENTS_PATH}/${docNo}`);
    AmplitudeUtils.amplitudeLogEvent(EVENTS.EVENT_NAMES.DOCUMENT_CREATED, {
      ...document,
      revision: revisionNo,
    });
  };

  _saveDocument = document => {
    this.setState({ isLoading: true });
    createDocumentAndContent(document)
      .then(details => {
        const {
          id,
          components: docComponents,
          doc_no: docNo,
          template_id: templateID,
        } = details.Document;
        const components = docComponents || [];
        if (!templateID) {
          const commentSection =
            components &&
            components.find(
              section => section.content.section_type === "Comments",
            );
          if (commentSection) {
            const notes = new CreateDocumentNotes({
              id,
              components,
              mode: "DOCUMENT",
            });
            notes.create();
            deleteDocumentComponentService(docNo, commentSection);
          }
          this._postDocCreationAction(docNo, details.revision_no);
        } else {
          this._postDocCreationAction(docNo, details.revision_no);
        }
      })
      .catch(error => {
        console.error(`CreateQuotePopup => _createDocument => ${error}`);
        this.setState({ isLoading: false });
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
      });
  };

  _createDoc = template => {
    this.setState({ isLoading: true });
    const { selectedCategoryID, selectedCategoryName, docURI, turnAroundDate } =
      this.state;
    const {
      id: opportunityID,
      name: opportunityName,
      crm_account: { id: accountID } = {},
    } = this.props.opportunity;
    const doc = {
      account: { id: accountID },
      deadline_date: turnAroundDate,
      doc_no: "",
      meta_values: {},
      opportunity: { id: opportunityID },
      template_id: template ? template.id : null,
      title: "",
      type: { id: selectedCategoryID, name: selectedCategoryName },
      uri: docURI,
      created_from: template ? "template" : "blank/upload",
    };
    if (this.props.quote && this.props.quote.id) {
      doc.quote_ids = [this.props.quote.id];
    }
    generateDocumentID(selectedCategoryID).then(res => {
      doc.doc_no = res;
      doc.title = makeDocTitle(
        opportunityName,
        selectedCategoryID,
        this.props.documentTypes,
        res,
      );
      this._saveDocument(doc);
    });
  };

  // _saveDocument = document => {
  //   this.setState({ isLoading: true });
  //   createDocumentAndContent(document)
  //     .then(details => {
  //       const { id, template_id: templateID } = details.Document;
  //       if (!templateID) {
  //         const { components } = details.Document;
  //         const notes = new CreateDocumentNotes({
  //           id,
  //           components,
  //           mode: "DOCUMENT",
  //         });
  //         const createdNotes = notes.create();
  //         console.debug(createdNotes);
  //       }
  //       this.setState({ isLoading: false });
  //       this.props.history.push(`${PATHS.DOCUMENTS_PATH}/${id}`);
  //       AmplitudeUtils.amplitudeLogEvent(EVENTS.EVENT_NAMES.DOCUMENT_CREATED, {
  //         ...document,
  //         revision: details.revision_no,
  //       });
  //     })
  //     .catch(error => {
  //       console.error(`CreateQuotePopup => _createDocument => ${error}`);
  //       Toastr.showToastr({
  //         type: "failure",
  //         message: handleApiErrMsg(error),
  //         timeout: 3000,
  //       });
  //       this.setState({ isLoading: false });
  //     });
  // };

  _setDoc = docDetails => {
    this.setState({ isLoading: true });
    const { name: opportunityName } = this.props.opportunity;
    const { fileDetails, error } = docDetails;
    if (error) {
      this.setState({ errMsg: error, isLoading: false });
    } else {
      saveDocument(fileDetails, opportunityName).then(uri => {
        if (typeof uri === "string") {
          this.setState({ docURI: uri, errMsg: "" });
          this._createDoc();
        } else {
          this.setState({
            docURI: undefined,
            errMsg: "Invalid content in the uploaded docx file",
          });
        }
      });
    }
  };

  // Select the document category in case of normal document creation
  _selectCategory = (categoryName, categoryID) => {
    this.props.updateSelectedDocCategory(categoryName);
    this.setState({ loadingTemplates: true });
    this.props
      .fetchDocumentTemplatesById(categoryID)
      .then(() => this.setState({ loadingTemplates: false }))
      .catch(error => {
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
        this.setState({ loadingTemplates: false });
      });
    this.setState({
      selectedCategoryID: categoryID,
      selectedCategoryName: categoryName,
    });
  };

  _chooseCategory = () => {
    const { documentTypes } = this.props;
    const { selectedCategoryID } = this.state;
    const category = documentTypes.map(item => {
      let className = "createdocumentpopup-categories-pills";
      if (selectedCategoryID === item.id) {
        className += " active";
      }
      let id = "document-category-default-id";
      if (item && item.name) {
        id = item.name.replace(/ +/g, "-").toLowerCase();
      }
      return (
        <span
          data-test="createdocpopup-doctype"
          className={className}
          key={item.id}
          id={id}
          onClick={() => this._selectCategory(item.name, item.id)}
          onKeyPress={() => this.props._selectCategory(item.name, item.id)}
          role="button"
          tabIndex="0">
          {item.name}
        </span>
      );
    });
    return category;
  };

  _selectTemplate = item => {
    this.setState({ selectedTemplate: item });
  };

  _selectSource = event => {
    if (event.target.value === "blank") {
      this.setState({ docSource: event.target.value, selectedTemplate: null });
    } else {
      this.setState({ docSource: event.target.value });
    }
  };

  _validateNext = () => {
    const { docSource, selectedCategoryID, docURI, selectedTemplate } =
      this.state;
    if (docSource === "blank") {
      return true;
    }
    if (docSource === "template" && selectedTemplate) {
      return true;
    }
    if (selectedCategoryID && docURI) {
      return true;
    }
    return false;
  };

  render() {
    const { show, closePopup } = this.props;
    const { name: opportunityName, crm_account: { name: accountName } = {} } =
      this.props.opportunity;

    // Header Section for Opportunity and Account Name
    const popupHeaderSpace = (
      <div className="pipeline-doc">
        <div className="account-details-container">
          <span className="account-details-metatitle">
            <i>
              <FontAwesomeIcon icon={["far", "crown"]} />
            </i>
            Opportunity
          </span>
          <span className="pipeline-opportunity">{opportunityName}</span>
        </div>
        <div className="account-details-container">
          <span className="account-details-metatitle">
            <i>
              <FontAwesomeIcon icon={["far", "briefcase"]} />
            </i>
            Account
          </span>
          <span className="pipeline-acc">{accountName}</span>
        </div>
      </div>
    );

    let errSpace = null;
    if (this.state.errMsg) {
      errSpace = (
        <div className="error-message-wrapper">
          <span className="error-message-icon">
            <FontAwesomeIcon icon={["far", "times-circle"]} />
          </span>
          {this.state.errMsg}
        </div>
      );
    }

    return (
      <div className="createdocumentpopup">
        <Modal
          open={show}
          onClose={closePopup}
          closeOnOverlayClick={false}
          center>
          {this.state.isLoading && (
            <LZLoader
              className="saving-document"
              label="Please wait while we create the document !"
              fullScreen
            />
          )}
          <div className="row">
            <div className="col-md-12">
              <div className="createdoc-title">Create New Document</div>
              <div className="popup-form">
                {popupHeaderSpace}
                {errSpace}
                <CreateDocFormFields
                  setTurnAroundDate={date => this._setTurnAroundDate(date)}
                  turnAroundDate={this.state.turnAroundDate}
                />

                {/* Select Document Types, If it is a case of normal document creation */}
                {!this.props.quote && (
                  <Fragment>
                    <div className="choose-category-title">
                      SELECT DOCUMENT TYPE
                    </div>
                    <div className="category-column">
                      {this._chooseCategory()}
                    </div>
                  </Fragment>
                )}

                {/* Template Selection Section */}
                {this.state.showTemplateSelection ? (
                  <div className="category-column choose-template-wrapper">
                    <div className="createdocpopup-category-title">
                      <div className="choose-category-title">
                        SELECT TEMPLATE TO CREATE DOCUMENT
                      </div>
                      <div
                        data-test="createdocpopup-create-upload-doc-btn"
                        id="create-upload-doc-btn"
                        className="get-back-to-templates"
                        onClick={() => this._setTemplateSelectionView(false)}
                        onKeyPress={() => {}}
                        role="button"
                        tabIndex="0">
                        + BLANK/UPLOAD DOC
                      </div>
                    </div>

                    <TemplateSelection
                      templates={this.props.documentTemplates}
                      loading={this.state.loadingTemplates}
                      setView={this._setTemplateSelectionView}
                      createDoc={this._createDoc}
                      pbListLength={this.props.pbookOptions.length}
                    />
                  </div>
                ) : (
                  <UploadTemplate
                    templates={this.props.documentTemplates}
                    loading={this.state.loadingTemplates}
                    setView={this._setTemplateSelectionView}
                    createDoc={this._createDoc}
                    setErrMsg={this._setErrMsg}
                    setDocUri={this._setDocUri}
                    setDoc={this._setDoc}
                  />
                )}
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { accounts, opportunitiesByAccount, allPriceLists } =
    state.OpportunitiesStore;
  const pbookOptions = allPriceLists.filter(pl => pl.active === true);
  const { documentTemplates } = state.TemplateStore;
  return {
    accounts,
    opportunitiesByAccount,
    documentTemplates,
    pbookOptions,
  };
};

const mapDispatchToProps = {
  fetchDocumentTemplatesById,
  updateSelectedDocCategory,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(CreateDocPopup));
